// @mui material components
import {
  styled,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide
} from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { forwardRef, use, useEffect, useState } from "react";
import Interpret from "./Interpret";
import { Icon } from "@iconify/react";
import useResponsive from "./hooks/useResponsive";
import { Grid } from "@mui/material";


const props = { window: () => Window }

function FullScreen(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const isLg = useResponsive('up', 'md');
  const handleClose = () => {
    navigate(-1); // go back when closed
  };
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <>
      {isLg ? (
        <Dialog fullScreen open={open}>
       
              <Interpret id={id} />
         </Dialog>

      ) : (
        <Interpret id={id} />

      )}
    </>

  );
}

export default FullScreen;